import React from "react";

import PublicTopBarView from "../views/PublicTopBarView";
import PropTypes from "prop-types";
import FooterView from "../views/FooterView";


class PublicWrapper extends React.Component {

    static propTypes = {
        children: PropTypes.object.isRequired,
        usesDefaultFooter: PropTypes.bool.isRequired
    };

    render() {
        let footer = null;
        if (this.props.usesDefaultFooter) {
            footer = (
                <div className="footer-contents mt-4">
                    <FooterView/>
                </div>
            );
        }

        return (
            <div className="main-contents">
                <PublicTopBarView />
                <div className="middle-contents">
                    {this.props.children}
                </div>
                {footer}
            </div>
        );
    }

}

export default PublicWrapper;